import React from 'react';
import { ArrowRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../config/api';
import { useI18n } from '../../i18n';
import SEO, { SEOConfigs } from '../common/SEO';

const About = () => {
  const { t } = useI18n();

  return (
    <div className="tafsir-page">
      <SEO {...SEOConfigs.about} />
      <div className="page-shell">
        <header className="grid gap-9 border-b border-border pb-10 lg:grid-cols-[1fr_.65fr] lg:items-end">
          <div>
            <p className="editorial-eyebrow mb-4">{t('about.eyebrow')}</p>
            <h1 className="editorial-title max-w-4xl">{t('about.title')}</h1>
          </div>
          <p className="editorial-lede max-w-xl lg:justify-self-end">{t('about.intro')}</p>
        </header>

        <section className="grid border-b border-border py-12 lg:grid-cols-[1.15fr_.85fr] lg:py-20">
          <div className="min-h-[480px] overflow-hidden bg-surface lg:mr-12">
            <img src={getImageUrl('/Images/1-The Art of Patience_WhatsApp Image 2024-08-12 at 19.03.37.jpeg')} alt="Tafsir Art calligraphy study" className="h-full w-full object-cover" />
          </div>
          <div className="flex flex-col justify-center border-t border-border pt-9 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0">
            <p className="editorial-eyebrow mb-3">01</p>
            <h2 className="section-title">{t('about.originTitle')}</h2>
            <p className="editorial-lede mt-5">{t('about.originCopy')}</p>
            <p className="mt-8 border-r-2 border-primary pr-5 text-right font-arabic text-2xl leading-10 text-text-secondary" dir="rtl" lang="ar">
              التفكر في المعنى، ثم تحويله إلى أثر بصري باقٍ
            </p>
          </div>
        </section>

        <section className="grid gap-10 py-14 lg:grid-cols-[.7fr_1.3fr] lg:py-20">
          <div>
            <p className="editorial-eyebrow mb-3">02</p>
            <h2 className="section-title">{t('about.practiceTitle')}</h2>
          </div>
          <div className="lg:pl-16">
            <p className="editorial-lede max-w-3xl">{t('about.practiceCopy')}</p>
            <div className="mt-10 grid gap-px border border-border bg-border sm:grid-cols-3">
              {['Tafsir', 'Tadabbur', 'Art'].map((term, index) => (
                <div key={term} className="bg-surface p-7">
                  <span className="editorial-eyebrow">0{index + 1}</span>
                  <h3 className="mt-4 font-display text-3xl font-semibold">{term}</h3>
                </div>
              ))}
            </div>
            <Link to="/gallery" className="btn-primary mt-10">{t('about.cta')} <ArrowRight size={17} /></Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
